import React from "react";

import { Control } from "src/components/common";

import styles from "./style.module.scss";

export const Controls = React.memo(() => {
  return (
    <div className={styles.controls}>
      <Control type="double" />
      <Control type="undo" />
      <Control type="repeat" />
    </div>
  );
});

Controls.displayName = "Controls";
